// extracted by mini-css-extract-plugin
export default {"root":"IconNoteBook_root__GvIzJ"};